import { Box, Paper, Typography } from '@mui/material'
import React, { useState } from 'react'
import CashFlowReportGrid from './CashflowReportGrid'

const CashFlowReport: React.FC<{
  setGridReference: Function
}> = ({ setGridReference }) => {
  const [hasData, setHasData] = useState(true) // Assume data initially to avoid flash

  const handleDataChange = (dataHasContent: boolean) => {
    setHasData(dataHasContent)
  }
  
  return (
    <Box
      margin={2}
      gap={1}
      display={'flex'}
      flexDirection={'column'}
      sx={{ height: 'calc(100% - 2.5rem)' }}
    >
      <Typography variant='h5'>Cash Flow Report for Liability:</Typography>
      
      <Box sx={{ flexGrow: 1, minHeight: 0 }}>
        <CashFlowReportGrid 
          setGridReference={setGridReference} 
          onDataChange={handleDataChange}
        />
      </Box>
      
      {/* Conditional message that only appears when no cashflow data is available*/}
      {!hasData && (
        <Paper
          sx={{
            padding: 2,
            textAlign: 'center',
            marginTop: 1,
            backgroundColor: '#ffebee',
            border: '1px solid #f44336',
            flexShrink: 0,
          }}
        >
          <Typography variant="body1" color="error" sx={{ fontWeight: 'medium' }}>
          Cash Flow Report not available. To include Cash Flow Report, please select the optional "Specify Liabilities to Match" in the Optimization Parameters
          </Typography>
        </Paper>
      )}
    </Box>
  )
}

export default CashFlowReport
